import React from 'react';
import styles from './SelectionListPane.module.css';
import { ISelectionItem } from '../../../Types/Analyse/ISelectionItem';
import SelectionList from '../SelectionList/SelectionList';

export type Category<T> = {
  id: string;
  title: string;
  data: ISelectionItem<T>[];
};

type SelectionListPaneProps = {
  categories: Category<string>[];
  onChange: (category: Category<string>) => void;
  color?: string;
  selectAllDisabled?: boolean;
  maxHeight?: string;
  /**
   * When set, Select All does not apply immediately.
   * Call `apply()` after the user confirms (e.g. via ConfirmAction).
   */
  requestSelectAll?: (selecting: boolean, apply: () => void) => void;
};

const SelectionListPane = ({
  categories,
  onChange,
  color,
  selectAllDisabled,
  maxHeight = "300px",
  requestSelectAll,
}: SelectionListPaneProps) => {

  const categoryChanged = (
    items: ISelectionItem<string>[],
    category: Category<string>
  ) => {
    onChange({ ...category, data: items });
  };

  return (
    <div className={styles.container}>
      {categories.map(cat => (
        <SelectionList
          key={cat.id}
          title={cat.title}
          data={cat.data}
          onChange={items => categoryChanged(items, cat)}
          color={color}
          selectAllDisabled={selectAllDisabled}
          maxHeight={maxHeight}
          requestSelectAll={requestSelectAll}
        />
      ))}
    </div>
  );
};

export default SelectionListPane;
